var _style, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 240",
    style: {
      enableBackground: "new 0 0 330 240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#015593;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,179.8H7.1c0,0,20.5,57.2,117.8,57.2s146.3-35.9,146.3-35.9v-28.6c0,0-54.1,41.8-149.2,41.8 C26.8,214.3,30.5,179.8,30.5,179.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,4.6C-25.1,30.3,3.5,157.8,3.5,157.8l11.6-10.3C12.2,47.6,132.9,22.2,196.5,16.3 c63.6-5.9,114.8,20.9,114.8,64.1s-29.3,58.4-29.3,58.4v19.1C352.3,129.2,353.6-13.7,195.7,4.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,172.5h24.1l11-14.7H67v14.7h24.9V86H65.5L6.3,172.5z M70.9,138.7h-19l19-31.5V138.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "86.8,56.6 70.9,79.2 95.6,79.2 95.6,172.5 120.8,172.5 120.8,79.2 155.2,79.2 150.8,56.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "213.3,172.5 213.3,86 182.6,86 169.1,135.4 155.2,86 125.6,86 125.6,172.5 144.9,172.5 144.9,105.3  161.8,172.5 177.9,172.5 193.2,107.2 193.2,172.5 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "189.9,56.6 184.1,79.2 218.5,79.2 218.5,172.5 244.8,172.5 244.8,84.1 279.5,84.1 271.1,56.6 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.1,64.2c0-4.1-3.4-7.6-7.6-7.6c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6 C291.7,71.7,295.1,68.3,295.1,64.2z M281.2,64.2c0-3.4,2.9-6.4,6.3-6.3c3.3-0.1,6.3,2.9,6.3,6.2c0,3.4-2.9,6.2-6.3,6.2 C284.1,70.4,281.2,67.5,281.2,64.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288,65.6c0.4,0.5,0.8,1,1,1.6c0.4,0.9,1,1.2,1.9,1.1c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.1-0.3 c-0.3-0.5-0.7-1.1-1-1.6c-0.4-0.6-0.8-1.3-1.5-1.7c0.1-0.1,0.2-0.1,0.3-0.1c1.3-0.3,2-1.5,1.8-2.7c-0.2-1-1-1.7-2.1-1.8 c-1.2-0.1-2.5,0-3.8-0.1c-0.3,0-0.4,0.1-0.4,0.4c0,1.8,0,3.5,0,5.2c0,0.7,0,1.4,0,2.1c0,0.4,0,0.4,0.4,0.4c0.2,0,0.4,0,0.6,0 c0.4,0,0.4-0.1,0.4-0.4c0-0.9,0-1.8,0-2.7c0-0.1,0-0.3,0.2-0.3C286.8,64.8,287.5,64.8,288,65.6z M286.1,63.6c-0.2,0-0.3-0.1-0.3-0.3 c0-0.6,0-1.2,0-1.8c0-0.2,0-0.3,0.2-0.3c0.8,0,1.5-0.1,2.2,0.1c0.7,0.1,1,0.4,1,1c0,0.7-0.2,1-0.9,1.2c-0.4,0.1-0.9,0.1-1.3,0.1 C286.7,63.6,286.4,63.6,286.1,63.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f27ea8457d732434389f790ac1c888a9.svg";
export { ForwardRef as ReactComponent };